import { BCA_ROUTES, BSA_ROUTES } from '../constants';
import { isBsaProduct } from './productUtil';

/**
 * Returns the base route map for the provided product type.
 * BSA products use `BSA_ROUTES`; all other products fall back to `BCA_ROUTES`.
 * @param {string} type Product type constant (ex. AEXP_BUSINESS_CHECKING_ACCOUNT).
 */
const getBaseRoute = (type) => {
  return isBsaProduct(type) ? BSA_ROUTES : BCA_ROUTES;
};

export default getBaseRoute;
